import { ReactElement, FC } from "react";
import styled from "styled-components/native";
import { coreTheme } from "@kolmeo/ui-core";

import type { IconProps } from "./types";
import Icons, { IconsProps } from "./components";

import IconWrapper from "./IconWrapper";

const getNounArticle = (noun: any) => (new RegExp(/\b[aeiou]\w*/gm).test(noun) ? "an" : "a");

const Icon = ({ type, outlined, color, size, accessible = true, testID, width, height, ...props }: IconProps): ReactElement | null => {
  const IconComponent = Icons[type] as FC<{
    accessible?: boolean;
    outlined?: boolean;
    color: string;
    strokeWidth: string;
  }>;

  if (!IconComponent) {
    throw new Error(`missing icon ${type}`);
  }

  const StyledIconComponent = styled(IconComponent)``;
  const iconType = IconsProps[type];
  const { palette } = coreTheme;

  return (
    <IconWrapper
      {...props}
      type={type}
      size={size}
      width={width}
      height={height}
      testID={testID ?? `icon-${type}`}
      title={accessible ? `${type} icon` : ""}
      description={accessible ? `This is ${getNounArticle(type)} ${type} icon` : ""}
      viewBox={iconType?.viewBox || "0 0 30 30"}
    >
      <StyledIconComponent
        outlined={typeof iconType?.outlined == "undefined" ? outlined : iconType?.outlined}
        color={color || palette.kolmeoBlack}
        strokeWidth={iconType?.strokeWidth || "1"}
      />
    </IconWrapper>
  );
};

export default Icon;
